export enum Languages {
  english = 'en-UK',
  greek = 'el-GR',
  turkish = 'tr-CY',
}
